import { render, staticRenderFns } from "./ChildrenIncomeRow.vue?vue&type=template&id=d76f4910&"
import script from "./ChildrenIncomeRow.vue?vue&type=script&lang=js&"
export * from "./ChildrenIncomeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports